import { Button, Typography, styled } from '@mui/material';
import Box from '@mui/system/Box';
import { NavLink } from 'react-router-dom';

export const SecondaryNav = ({ title, children }) => {
  return (
    <Box
      alignItems={'center'}
      bgcolor={'grey.50'}
      borderBottom={1}
      color={'grey.300'}
      display={'flex'}
      height={'50px'}
      pl={3}
      pr={3}
    >
      {title && (
        <Box color={'initial'} pr={2}>
          <Typography sx={{ fontWeight: 'bold' }} variant="h5">
            {title}
          </Typography>
        </Box>
      )}
      {children}
    </Box>
  );
};

export const SecondaryNavLink = ({ startIcon, children, ...props }) => {
  return (
    <Button
      size="small"
      variant="text"
      {...props}
      end
      component={NavLink}
      startIcon={startIcon}
      sx={{
        color: 'grey.600',
        '&.active': {
          color: 'primary.main',
        },
      }}
    >
      {children}
    </Button>
  );
};
